import React from "react";
import { Animate } from "react-move";

export const LOADING_INDICATOR_FINISH_DURATION = 1000;

export function DefaultLoader({finished, progress, duration} = {finished: false, progress: false, duration: 5}) {
    return (
        <div aria-label='loading-indicator'>
            <AnimateProgress finished={finished} duration={duration}>
                {value => (
                    <div className='w-full'>
                        <Spinner progress={progress} value={value}/>
                    </div>
                )}
            </AnimateProgress>
        </div>
    );
}

export function Spinner({value, progress} = {value:1, progress: true}) {
    return (
        <div className='relative'>
            <svg className="loading-indicator-spinner stroke-current text-green" viewBox="0 0 50 50">
                <circle className={(100 !== value)? "path" : ""} cx={25} cy={25} r={20} fill="none" strokeWidth={4} strokeLinecap='round'/>
            </svg>
            {progress && (
                <div className='absolute top-0 left-0 w-full h-full flex justify-center items-center'>
                    <div className='text-green text-2xl'>{`${value}%`}</div>
                </div>
            )}
        </div>
    );
}

function AnimateProgress({children, finished, duration= 22}) {
    const startValue = finished ? 100 : 0;
    const intermediateValue = finished ? 100 : 90;
    const finishValue = 100;

    return (
        <Animate
            start={{
                value: startValue
            }}
            enter={{
                value: [
                    intermediateValue
                ],
                timing: {
                    duration: duration * 1000,
                }
            }}
            update={{
                value: [
                    finished ? finishValue : intermediateValue
                ],
                timing: {
                    duration: finished ? LOADING_INDICATOR_FINISH_DURATION : (duration * 1000),
                }
            }}
        >
            {({ value }) => children(Math.round(value))}
        </Animate>
    );

}
